import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';
import * as ProjectConfig from '../../assets/project.config.json';

@Injectable()

export class customInterceptor implements HttpInterceptor {
  appMode
  project_config = ProjectConfig['default']
  constructor(private ConfigService: ConfigService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    // console.log("Request url", req.url.indexOf('http://localhost:3000/chitactivity/'), req.url )
    // var activity = req.url.substring(0, req.url.lastIndexOf('/'));

    if (req.url.indexOf('https://nodesdms.azurewebsites.net/chitactivity/') === 0) {
      const newReq = req.clone({
        headers: req.headers.set('Authorization', "Bearer " + this.ConfigService.accessToken).set('Authentication', 'no'),
      })
      return next.handle(newReq);
    } else {
      const newReq = req.clone({
        headers: req.headers.set('Authorization', "Bearer " + this.ConfigService.accessToken).set('Authentication', this.project_config['authentication']).set('appmode', this.ConfigService.appMode),
      })
      return next.handle(newReq);
    }
  }

}
